//adding spin.js which might be a global dependancy.
import {Spinner} from 'spin.js';
window.Spinner = Spinner;

//spinner - based on spin.js -- does not seem to be working!
require("./spinner.js");

// To remove widows.
require("./widont");

// Miscellaneous code.
require("./lazy-loader");

// Other components.
require("./components");

// AHP, Menu, Masthead and footer related code.
require("./menu-masthead-footer");

// To convert EPi dropdowns to custom dropdowns.
require("./custom-dropdown");

// To drive search functionality.
require("./search");

// Homepage scripts
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('div[data-personalized-content="personalizedContent"]')) {
      import(/* webpackChunkName: "personalized-content" */ './personalized-content')
        .then((module) => {
          module.initPersonalizedContent();
        })
        .catch((error) => {
          console.error("Error loading personalized-content:", error);
        });
    }

    if (document.querySelector('input.ETH.Address')) {
      import(/* webpackChunkName: "forms-and-subscriptions" */ './forms-and-subscriptions')
        .then((module) => {
          module.validateETH();
        })
        .catch((error) => {
          console.error("Error loading forms-and-subscriptions:", error);
        });
    }

    if (document.querySelector('form input[value=marketo-cookie-id]')) {
      import(/* webpackChunkName: "marketo-cookie" */ './marketo-cookie')
        .then((module) => {
          module.bindMarketoCookie();
        })
        .catch((error) => {
          console.error("Error loading marketo-cookie:", error);
        });
    }

    if (document.querySelector('.video-js')) {
      import(/* webpackChunkName: "video-player" */ './video-player')
        .then((module) => {
          module.initVideoPlayer();
        })
        .catch((error) => {
          console.error("Error loading video-player:", error);
        });
    }

    if (document.body.classList.contains("home-page")) {
      import(/* webpackChunkName: "home-page" */ './home-page')
        .then((module) => {
          module.homepageScripts(); 
        })
        .catch((error) => {
          console.error("Error loading home-page:", error);
        });
    }

    if (document.querySelector("body.page-class-insights") || document.querySelector("body.voices-page")) {
      import(/* webpackChunkName: "insights-components" */ './insights-components')
        .then((module) => {
          module.initInsightsComponents();
        })
        .catch((error) => {
          console.error("Error loading insights-components:", error);
        });
    }
});

//export jQuery for outside use.
window.$ = $;

//au header scripts
require("./global-nav-au");
require("./nav-au");
require("./mobile-responsive-au");

//lazy loading scripts
require("./lazy-scripts");

//au webinar
require("./webinar-au");

//au popups
require("./sticky-gated-content/initializer.js");